var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "BModal",
        {
          attrs: { active: "", "has-modal-card": "" },
          on: { close: _vm.close }
        },
        [
          _c(
            "keep-alive",
            [_c(_vm.component, { ref: "componentRef", tag: "component" })],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }